import React from 'react';

import Button from '../../../../components/Button';
import RoundTextInput from '../../../../components/RoundTextInput';

import '../../styles.css';


const Component = ({
  submit,
  update,
  skip,
  loading,
  error,
}) => (
  <div className="waitlist_inherit">
    <div className="waitlist_header">
      Your Region
    </div>
    <div className="waitlist_body">
      By entering your ZIP code we’ll be able to ensure there are actions
      and communities available in your area when we launch.
    </div>
    <div className="waitlist_inherit">
      <div className="waitlist_error">
        { error }
      </div>
      <RoundTextInput onChange={update}
                      placeholder="ZIP Code"
      />
      <Button onClick={submit} loading={loading}>
        Submit
      </Button>
      <div className="waitlist_skip" onClick={skip}>
        skip
      </div>
    </div>
  </div>
);

Component.displayName = 'Desktop';

export default Component;



// WEBPACK FOOTER //
// ./src/forms/JoinWaitlist/components/Zipcode/Desktop.js